var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLaunchSupport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_119_51746)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.052 118.776C108.052 114.3 108.071 110.071 108.052 105.841C108.033 102.93 106.696 100.663 104.164 100.322C101.413 99.9523 98.53 99.9618 95.7702 100.341C93.3138 100.682 91.9765 102.939 91.9576 105.756C91.9196 109.464 91.9481 113.181 91.9481 116.898C91.9481 117.458 91.9481 118.027 91.9481 118.738C88.8183 118.738 85.8498 118.804 82.8908 118.709C81.6769 118.671 80.9371 117.78 80.6241 116.623C77.0771 103.736 75.1328 90.6496 76.2235 77.2598C76.7736 70.5364 78.7937 64.1545 81.9234 58.1708C82.1795 57.6777 83.0141 57.194 83.5831 57.1845C94.5088 57.1276 105.444 57.1561 116.37 57.1182C117.375 57.1182 117.84 57.4975 118.266 58.3509C122.316 66.4493 124.27 75.0313 124.147 84.0685C123.995 94.9358 122.534 105.623 119.547 116.083C118.93 118.235 118.247 118.776 115.981 118.785C113.43 118.785 110.878 118.785 108.09 118.785L108.052 118.776ZM99.9716 91.9298C107.426 91.9203 113.439 85.8892 113.401 78.4641C113.363 71.1528 107.265 65.1312 99.9337 65.1691C92.593 65.2071 86.5611 71.2666 86.5801 78.5874C86.6086 85.9556 92.612 91.9487 99.9716 91.9298Z",
    fill: "url(#paint0_linear_119_51746)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.807 119.175C158.849 121.09 164.71 122.949 170.58 124.808C164.397 144.504 146.681 163.327 124.848 170.695C122.98 164.797 121.102 158.899 119.186 152.848C126.935 149.909 133.792 145.604 139.643 139.762C145.495 133.911 149.839 127.084 152.807 119.175Z",
    fill: "url(#paint1_linear_119_51746)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8042 152.848C78.9169 158.813 77.058 164.673 75.2086 170.524C59.1521 168.23 33.308 142.465 29.3911 124.826C35.2807 122.958 41.1798 121.09 47.1453 119.203C53.4712 135.305 64.6055 146.476 80.8042 152.848Z",
    fill: "url(#paint2_linear_119_51746)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.1137 29.1816C77.0485 35.2791 78.9074 41.1395 80.8137 47.1612C73.0557 50.1008 66.1987 54.4061 60.3565 60.257C54.5049 66.1079 50.1517 72.9261 47.2116 80.8253C41.2272 78.9288 35.3281 77.0606 29.1919 75.1261C37.6422 52.9173 52.8357 37.7257 75.1137 29.1816Z",
    fill: "url(#paint3_linear_119_51746)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.205 47.105C121.093 41.1402 122.97 35.2419 124.896 29.1729C147.126 37.679 162.329 52.8895 170.818 75.1268C164.795 77.0329 158.934 78.8915 152.931 80.7976C146.643 64.6198 135.433 53.4016 119.205 47.1144V47.105Z",
    fill: "url(#paint4_linear_119_51746)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5803 114.072C39.5674 115.979 33.6683 117.837 27.6649 119.743C24.1084 106.505 24.1274 93.4852 27.6649 80.2471C33.6494 82.1436 39.501 83.9928 45.5614 85.9178C43.1903 95.2774 43.1619 104.628 45.5993 114.072H45.5803Z",
    fill: "url(#paint5_linear_119_51746)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.217 154.868C116 160.501 117.849 166.361 119.746 172.345C106.535 175.873 93.5035 175.892 80.2732 172.326C82.17 166.323 84.0384 160.425 85.8024 154.868C90.6867 155.333 95.3434 156.129 100 156.129C104.657 156.129 109.323 155.342 114.217 154.868Z",
    fill: "url(#paint6_linear_119_51746)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.345 119.734C166.341 117.837 160.452 115.969 154.856 114.196C155.321 109.35 156.117 104.694 156.127 100.038C156.136 95.3725 155.378 90.707 154.922 85.7759C160.452 84.0215 166.341 82.1629 172.335 80.2568C175.882 93.476 175.863 106.496 172.345 119.725V119.734Z",
    fill: "url(#paint7_linear_119_51746)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.3756 43.8234C83.6115 38.2475 81.9518 33.013 80.2637 27.6646C93.4845 24.118 106.506 24.1275 119.727 27.6457C118.039 33.0035 116.379 38.2475 114.691 43.5958C112.908 41.9079 111.315 40.2579 109.56 38.7975C107.597 37.157 105.539 35.6302 103.433 34.1794C101.186 32.6242 98.7481 32.5198 96.5763 34.2078C93.162 36.8535 89.8805 39.6794 86.5611 42.4579C86.1722 42.7803 85.8877 43.226 85.3756 43.8329V43.8234Z",
    fill: "url(#paint8_linear_119_51746)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7694 135.561C29.5619 138.567 31.2122 141.279 32.7865 144.038C33.0521 144.493 33.0426 145.138 33.0426 145.698C33.0615 150.771 33.0426 155.844 33.0615 160.927C33.071 164.891 35.0911 166.93 39.0365 166.939C44.1105 166.958 49.1845 166.911 54.2584 166.977C55.0835 166.987 55.994 167.29 56.7243 167.698C59.2281 169.082 61.6845 170.581 64.3874 172.174C63.7994 172.231 63.3821 172.307 62.9648 172.307C54.9603 172.307 46.9557 172.335 38.9512 172.307C32.189 172.278 27.741 167.85 27.7125 161.107C27.6746 153.047 27.703 144.996 27.7125 136.936C27.7125 136.575 27.7505 136.215 27.7884 135.57L27.7694 135.561Z",
    fill: "url(#paint9_linear_119_51746)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.306 135.835C172.306 136.338 172.306 136.831 172.306 137.334C172.306 145.129 172.316 152.923 172.306 160.718C172.297 167.973 167.944 172.288 160.651 172.297C152.855 172.306 145.059 172.297 137.263 172.297H135.869C135.831 172.202 135.793 172.107 135.755 172.003C136.988 171.32 138.354 170.808 139.425 169.936C142.858 167.176 146.756 166.588 151.015 166.882C154.239 167.11 157.502 166.93 160.745 166.92C164.985 166.92 166.938 164.938 166.938 160.652C166.938 155.683 166.91 150.714 166.976 145.745C166.986 144.91 167.28 144.01 167.688 143.279C169.082 140.766 170.58 138.31 172.031 135.835C172.126 135.835 172.212 135.826 172.306 135.816V135.835Z",
    fill: "url(#paint10_linear_119_51746)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.594 27.7973C136.267 27.7499 136.703 27.693 137.149 27.693C145.049 27.693 152.95 27.674 160.85 27.693C167.915 27.712 172.288 32.0836 172.307 39.1483C172.326 47.0475 172.307 54.9468 172.307 62.846C172.307 63.2822 172.25 63.7279 172.212 64.3822C170.438 61.4046 168.779 58.6546 167.176 55.8666C166.939 55.4494 166.958 54.8614 166.958 54.3493C166.939 49.2191 166.958 44.0984 166.948 38.9681C166.939 35.1181 164.89 33.0698 161.03 33.0508C155.956 33.0319 150.882 33.0793 145.808 33.0129C144.973 33.0034 144.063 32.7284 143.333 32.3206C140.8 30.9172 138.325 29.3999 135.594 27.7878V27.7973Z",
    fill: "url(#paint11_linear_119_51746)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.5771 27.6934C61.4948 29.5236 58.8677 31.1357 56.1932 32.6434C55.6431 32.9564 54.9034 33.0322 54.2584 33.0322C49.1845 33.0607 44.1105 33.0322 39.0365 33.0512C35.1006 33.0607 33.0805 35.0995 33.071 39.0728C33.0615 44.0987 33.0995 49.1152 33.0331 54.1411C33.0236 55.023 32.7106 55.9713 32.2839 56.7489C30.9087 59.2524 29.4102 61.6895 27.8169 64.4111C27.7694 63.6998 27.7125 63.2257 27.7125 62.7421C27.7125 54.8903 27.6936 47.0479 27.7125 39.1961C27.7315 32.0365 32.0847 27.6934 39.2736 27.6839C47.0695 27.6744 54.8654 27.6839 62.6613 27.6839C63.164 27.6839 63.6761 27.6839 64.5961 27.6839L64.5771 27.6934Z",
    fill: "url(#paint12_linear_119_51746)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.39 106.458C131.895 106.989 134.797 110.156 134.816 114.585C134.854 121.697 134.854 128.809 134.797 135.912C134.797 136.538 134.399 137.277 133.953 137.751C133.194 138.576 132.255 139.25 131.259 140.094C129.173 134.897 127.238 129.9 125.142 124.959C124.07 122.427 123.473 120.17 124.63 117.306C125.996 113.912 126.489 110.166 127.38 106.458H127.39Z",
    fill: "url(#paint13_linear_119_51746)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.6004 106.448C73.473 110.033 74.3265 113.522 75.1801 117.012C75.2465 117.268 75.256 117.553 75.3982 117.761C76.9346 120.104 75.9862 122.228 75.0284 124.485C72.8755 129.577 70.8933 134.736 68.7499 140.103C67.6213 139.126 66.5591 138.301 65.6202 137.353C65.3167 137.04 65.1934 136.433 65.1839 135.949C65.1554 128.837 65.146 121.735 65.1744 114.622C65.1934 110.194 68.0291 107.065 72.6004 106.448Z",
    fill: "url(#paint14_linear_119_51746)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.894 51.6562H85.717C87.3293 49.7502 88.5717 47.9389 90.1556 46.488C92.9913 43.8803 96.0073 41.4621 99.0042 39.044C99.4026 38.7216 100.351 38.5983 100.749 38.8543C105.899 42.1639 110.29 46.2889 113.866 51.2674C113.913 51.3338 113.885 51.4571 113.904 51.6562H113.894Z",
    fill: "url(#paint15_linear_119_51746)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.4204 105.424H102.599V140.112H97.4204V105.424Z",
    fill: "url(#paint16_linear_119_51746)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8057 129.349C86.6938 129.937 85.8308 129.141 86.267 124.229H91.8057V129.349Z",
    fill: "url(#paint17_linear_119_51746)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.185 124.182H113.61C114.662 128.601 113.268 129.947 108.185 129.35V124.182Z",
    fill: "url(#paint18_linear_119_51746)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.9715 86.5627C95.5614 86.5532 91.9954 83.0066 91.9574 78.6065C91.929 74.1875 95.5993 70.4987 100.028 70.5177C104.401 70.5366 107.995 74.1211 108.042 78.5117C108.09 82.9497 104.448 86.5721 99.9715 86.5627Z",
    fill: "url(#paint19_linear_119_51746)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_119_51746",
    x1: 100.036,
    y1: 57.1182,
    x2: 100.036,
    y2: 118.785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_119_51746",
    x1: 144.883,
    y1: 119.175,
    x2: 144.883,
    y2: 170.695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_119_51746",
    x1: 55.0977,
    y1: 119.203,
    x2: 55.0977,
    y2: 170.524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_119_51746",
    x1: 55.0028,
    y1: 29.1816,
    x2: 55.0028,
    y2: 80.8253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_119_51746",
    x1: 145.011,
    y1: 29.1729,
    x2: 145.011,
    y2: 80.7976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_119_51746",
    x1: 35.302,
    y1: 80.2471,
    x2: 35.302,
    y2: 119.743,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_119_51746",
    x1: 100.01,
    y1: 154.868,
    x2: 100.01,
    y2: 174.996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_119_51746",
    x1: 164.923,
    y1: 80.2568,
    x2: 164.923,
    y2: 119.734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_119_51746",
    x1: 99.9953,
    y1: 25.0059,
    x2: 99.9953,
    y2: 43.8329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_119_51746",
    x1: 46.0404,
    y1: 135.561,
    x2: 46.0404,
    y2: 172.319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_119_51746",
    x1: 154.033,
    y1: 135.816,
    x2: 154.033,
    y2: 172.301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_119_51746",
    x1: 153.954,
    y1: 27.6846,
    x2: 153.954,
    y2: 64.3822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_119_51746",
    x1: 46.1501,
    y1: 27.6797,
    x2: 46.1501,
    y2: 64.4111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_119_51746",
    x1: 129.422,
    y1: 106.458,
    x2: 129.422,
    y2: 140.094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_119_51746",
    x1: 70.6832,
    y1: 106.448,
    x2: 70.6832,
    y2: 140.103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_119_51746",
    x1: 99.8104,
    y1: 38.7168,
    x2: 99.8104,
    y2: 51.6562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_119_51746",
    x1: 100.01,
    y1: 105.424,
    x2: 100.01,
    y2: 140.112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_119_51746",
    x1: 88.987,
    y1: 124.229,
    x2: 88.987,
    y2: 129.516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_119_51746",
    x1: 111.061,
    y1: 124.182,
    x2: 111.061,
    y2: 129.484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_119_51746",
    x1: 100,
    y1: 70.5176,
    x2: 100,
    y2: 86.5627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_119_51746"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    fill: "white",
    transform: "translate(25 25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaunchSupport);
export default __webpack_public_path__ + "static/media/Launch_Support.04acb0921e8ff9adbf6569effad38ffc.svg";
export { ForwardRef as ReactComponent };